<template>
    <common-modal :heading="heading" class="upload-photo">
        <common-content-wrapper width="medium">
            <common-image-cropper
                :uploadApi="uploadPhotoApi"
                :defaultPhoto="previousPhoto"
                :boundary="setBoundaries"
                :viewport="setViewport"
                @emitEvent="emitEvent($event)"
            ></common-image-cropper>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import WindowResizeMixin from 'mixins/WindowResizeMixin'

    export default {
        mixins: [WindowResizeMixin],

        props: {
            heading: { type: String, required: true },
            uploadPhotoApi: { type: Function, default: function () {} },
            previousPhoto: { type: String, default: null },
        },

        computed: {
            setBoundaries() {
                return this.isSmartphoneLarge ? { width: 290, height: 290 } : undefined
            },

            setViewport() {
                return this.isSmartphoneLarge ? { width: 250, height: 250, type: 'circle' } : undefined
            },
        },
    }
</script>

<style>
    .upload-photo {
        text-align: center;
    }
</style>
